export default __webpack_public_path__ + "static/media/pic8.f7f7e60f.jpg";